import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLanguage, initializeLanguage } from '../store/userSlice';
import './Header.scss';

const Header = ({ className, hearts }) => {
  const dispatch = useDispatch();
  const { initData, language, userData } = useSelector(state => state.user);
  
  // Инициализируем язык только при первом рендере
  useEffect(() => {
    if (initData && !language) { // Добавляем проверку на отсутствие языка
      const tgLanguage = JSON.parse(new URLSearchParams(initData).get('user'))?.language_code;
      console.log('🌍 Язык из Telegram:', tgLanguage);
      dispatch(initializeLanguage(tgLanguage));
    }
  }, [initData]); // Убираем dispatch из зависимостей

  const toggleLanguage = () => {
    console.log('🔄 Переключаем язык');
    dispatch(setLanguage(language === 'RUS' ? 'ENG' : 'RUS'));
  };

  const isPC = () => {
    return !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  };

  return (
    <div className={`header ${isPC() && 'header-desctop'} ${className}`}>
      <div 
        className="header-lang"
        onClick={toggleLanguage}
      >
        {language}
      </div>
      <div className="header-points">
        {!hearts && <span>{userData && userData.death_date ? '30' : 0}</span>}
        {hearts && <span>{hearts || 0}</span>}
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none">
          <path d="M21.1422 1.85676C19.9379 0.665541 18.3434 0.0144683 16.6417 0.0144683C14.94 0.0144683 13.3407 0.670364 12.1363 1.86159L11.5073 2.48372L10.8686 1.85194C9.6642 0.660719 8.06 0 6.35829 0C4.66145 0 3.06214 0.655896 1.86265 1.8423C0.658282 3.03352 -0.00484927 4.61539 2.66994e-05 6.29853C2.66994e-05 7.98167 0.668034 9.55872 1.8724 10.7499L11.0295 19.8071C11.1562 19.9325 11.3269 20 11.4927 20C11.6585 20 11.8291 19.9373 11.9559 19.8119L21.1325 10.7692C22.3368 9.57801 23 7.99614 23 6.313C23.0048 4.62985 22.3466 3.04799 21.1422 1.85676Z" fill="#AE0000"/>
        </svg>
      </div>
    </div>
  );
};

export default Header;